// extracted by mini-css-extract-plugin
module.exports = {"blackout":"blackout_blackout__3wQmC"};